import { openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode, defineComponent } from 'vue'
const _hoisted_1 = {
  xmlns: 'http://www.w3.org/2000/svg',
  'xmlns:xlink': 'http://www.w3.org/1999/xlink',
  viewBox: '0 0 512 512'
}
const _hoisted_2 = /*#__PURE__*/ _createStaticVNode('<path fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32" d="M176 112l80-80l80 80"></path><path fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32" d="M255.98 32l.02 448"></path><path fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32" d="M176 400l80 80l80-80"></path><path fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32" d="M400 176l80 80l-80 80"></path><path fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32" d="M112 176l-80 80l80 80"></path><path fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32" d="M32 256h448"></path>', 6)
const _hoisted_8 = [_hoisted_2]
export default defineComponent({
  name: 'MoveSharp',
  render: function render(_ctx, _cache) {
    return _openBlock(), _createElementBlock('svg', _hoisted_1, _hoisted_8)
  }
})
